<template>
  <div class="cookie-layer" v-if="!accepted">
    <div class="cookie-layer__card">
      <div class="cookie-layer__copy" v-html="copy"></div>
      <button class="cookie-layer__button" @click="onAccept">
        {{ btnLabel }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accepted: false
    };
  },
  props: {
    copy: {
      type: String
    },
    btnLabel: {
      type: String
    }
  },
  created() {
    if (
      document.cookie.replace(
        /(?:(?:^|.*;\s*)consent\s*\=\s*([^;]*).*$)|^.*$/,
        "$1"
      ) === "true"
    ) {
      this.accepted = true;
      this.loadAnalytics();
    } else {
      document.body.classList.add("modal-open");
    }
  },
  methods: {
    onAccept() {
      this.accepted = true;
      let date = new Date();
      date.setTime(date.getTime() + 1000 * 60 * 60 * 24 * 365);
      const expires = "expires=" + date.toUTCString();
      document.cookie = "consent=true; " + expires + "; path=/;";
      document.body.classList.remove("modal-open");

      this.loadAnalytics();
    },
    loadAnalytics() {
      var _gaq = _gaq || [];
      _gaq.push(["_setAccount", "UA-XXXXX-X"]);
      _gaq.push(["_trackPageview"]);

      var ga = document.createElement("script");
      ga.type = "text/javascript";
      ga.async = true;
      ga.src =
        ("https:" == document.location.protocol
          ? "https://ssl"
          : "http://www") + ".google-analytics.com/ga.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(ga, s);
    }
  }
};
</script>

<style lang="scss" scoped>
.cookie-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparentize(black, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  &__card {
    background: white;
    padding: 20px;
    width: calc(100% / 12 * 10);
  }

  &__copy {
    color: transparentize(black, 0.3);
    line-height: 1.8;
  }

  &__button {
    background: $color-blue;
    border: 0;
    color: white;
    font-size: 18px;
    padding: 10px 30px;
    border-radius: 1000px;
    cursor: pointer;

    &:hover {
      background: darken($color-blue, 5);
    }
  }

  @include breakpoint-from($device-medium) {
    &__card {
      background: white;
      padding: 20px;
      width: calc(100% / 12 * 8);
    }
  }

  @include breakpoint-from($device-large) {
    &__card {
      width: calc(100% / 12 * 4);
    }
  }
}
</style>

<style lang="scss">
.cookie-layer {
  a {
    text-decoration: none;
    color: $color-blue;

    &:hover {
      color: darken($color-blue, 5);
    }
  }
}
</style>
